import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=2b4a8906&scoped=true&"
import script from "./recharge.vue?vue&type=script&lang=js&"
export * from "./recharge.vue?vue&type=script&lang=js&"
import style0 from "./recharge.vue?vue&type=style&index=0&id=2b4a8906&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a8906",
  null
  
)

export default component.exports